import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './guards/login/login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'walkthrough',
    pathMatch: 'full'
  },
  {
    path: 'walkthrough',
    loadChildren: '../pages/walkthrough/walkthrough.module#WalkthroughModule'
  },
  {
    path: 'auth',
    loadChildren: '../pages/auth/auth.module#AuthModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'dashboard',
    loadChildren: '../pages/dashboard/dashboard.module#DashboardModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'feed',
    loadChildren: '../pages/feed/feed.module#FeedModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'profile',
    loadChildren: '../pages/profile/profile.module#ProfileModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'profile/:id',
    loadChildren: '../pages/profile/profile.module#ProfileModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'people',
    loadChildren: '../pages/people/people.module#PeopleModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'chat',
    loadChildren: '../pages/chat/chat.module#ChatModule'
  },
  {
    canActivate: [LoginGuard],
    path: 'setting',
    loadChildren: '../pages/setting/setting.module#SettingModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes) // , { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
